import { useTranslation } from 'react-i18next';
import FeatureTile, {
    FeatureItem,
    FeatureTileComponent,
} from '../../FeatureTile/FeatureTile';
import { useSelector } from '../../../../store/hooks';
import { useFeatureStatus, useIssueFeatureItems } from '../../healthUtils';
import { LinkMultipleRegular } from '@fluentui/react-icons';
import { FeatureServiceKey } from '../../../../store/features/healthDashboard/healthDashboardSlice';
import { useMemo } from 'react';

const relatedServices: readonly FeatureServiceKey[] = ['functionApp'] as const;

const ConnectionsTile: FeatureTileComponent = ({ className }) => {
    const { t } = useTranslation();

    const { healthInfo } = useSelector((x) => x.healthDashboard);

    const info = healthInfo?.connections;

    const status = useFeatureStatus(
        info && (info.failedCount > 0 || info.messageErrorCount > 0),
        info?.lastSuccessOnUtc,
        info?.lastErrorOnUtc
    );

    const errorItems = useIssueFeatureItems(info?.messageErrorCount, status);

    const items = useMemo<FeatureItem[]>(() => {
        const unkownValue = '?';

        return [
            {
                id: 'establishedCount',
                label: t('Health_Connections_EstablishedCount').replace(
                    '{count}',
                    info?.establishedCount.toString() ?? unkownValue
                ),
                status: 'Ok',
            },
            {
                id: 'failedCount',
                label: t('Health_Connections_FailedCount').replace(
                    '{count}',
                    info?.failedCount.toString() ?? unkownValue
                ),
                status: 'Error',
            },
        ];
    }, [info, t]);

    return (
        <FeatureTile
            title={t('Health_Connections_Title')}
            icon={<LinkMultipleRegular />}
            status={status}
            items={[...items, ...errorItems]}
            relatedServices={relatedServices}
            className={className}
        />
    );
};

export default ConnectionsTile;
